import { SettingPointCollection } from 'components/loyalty-program/setting-point-collection/SettingPointCollection'
import { useFetch } from 'services/useFetch'
import { API_SETTING_POINT_COLLECTION } from 'services/apiSettingPointCollection'
import { useState } from 'react'
import { Alert } from 'avo-ui'
import { capitalize, convertErrorMessage } from 'utils/utils'
import { useValidation } from 'hooks/useValidation'
import { SETTING_POINT_COLLECTION_VALIDATION } from 'services/validation/settingPointCollectionValidation'

const GET_FIELD_NAME = {
    total_point: 'Nilai point',
    min_transaction: 'Minimal order',
    max_amount: 'Maximal point per order',
}

export const SettingPointCollectionContainer = () => {
    const {
        fetching: getPointCollectionList,
        data: pointCollectionList,
        isLoading,
    } = useFetch(API_SETTING_POINT_COLLECTION.LIST, {}, { isFetching: true })
    const { fetching: updatePointCollection, isLoading: isUpdating } = useFetch(API_SETTING_POINT_COLLECTION.UPDATE)
    const [showModalEdit, setShowModalEdit] = useState(false)
    const [pointCollectionDetail, setPointCollectionDetail] = useState({})
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: pointCollectionDetail,
        schema: SETTING_POINT_COLLECTION_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        const newData = { [name]: checked === undefined ? value : checked }
        setPointCollectionDetail({ ...pointCollectionDetail, ...newData })
    }

    const onHideForm = () => {
        setShowModalEdit(false)
        setErrorMessage({})
        clearErrorForm()
    }

    const onEditRow = (item) => {
        const { min_transaction, max_amount, ...itemRest } = item
        const newDetail = item?.name === 'order-completed' ? item : itemRest
        setPointCollectionDetail(newDetail)
        setShowModalEdit(true)
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            const { id, name, ...payload } = pointCollectionDetail
            updatePointCollection(payload, id)
                .then(() => {
                    setShowModalEdit(false)
                    getPointCollectionList()
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: `${capitalize(name?.replace('-', ' '))} Updated !`,
                    })
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, GET_FIELD_NAME)))
        })
    }

    const props = {
        dataList: pointCollectionList?.data,
        isLoading,
        onEditRow,
        onChangeForm,
        showModalEdit,
        onHideForm,
        pointCollectionDetail,
        errorForm: { ...errorForm, ...errorMessage },
        onSubmit,
        isUpdating,
    }

    return <SettingPointCollection {...props} />
}
